import React from "react";

function ShowMoreText({
  handleSuccess,
  style,
  showtext = false,
}: {
  handleSuccess: () => void;
  style?: any;
  showtext?: boolean;
}) {
  return (
    <>
      <p className="show_more_text" onClick={handleSuccess} style={style}>
        Show {showtext ? "Less" : "More"}
      </p>
    </>
  );
}

export default ShowMoreText;
